import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { getStayDurationMeta } from '../../utils/bookingStayDisplay';

/**
 * Drawer row for nights, hourly stays, or checked-out stay:
 * separate chips — e.g. "Booked 16 N" + "8d 8h 46m".
 */
export default function StayDurationChip({
  booking,
  isDark,
  accentColor,
  captionSx,
  chipSx,
}) {
  const meta = getStayDurationMeta(booking);
  const accent = accentColor || '#4CE1B6';

  const bookedChipSx = {
    backgroundColor: isDark ? 'rgba(76, 225, 182, 0.15)' : 'rgba(76, 225, 182, 0.1)',
    color: accent,
    fontWeight: 600,
    fontSize: '0.7rem',
    height: 22,
    border: `1px solid ${accent}40`,
    ...chipSx,
  };

  const stayChipSx = {
    backgroundColor: isDark ? 'rgba(255, 167, 38, 0.2)' : 'rgba(255, 167, 38, 0.12)',
    color: isDark ? '#ffb74d' : '#ef6c00',
    fontWeight: 600,
    fontSize: '0.7rem',
    height: 22,
    border: `1px solid ${isDark ? '#ffb74d60' : '#ef6c0040'}`,
    ...chipSx,
  };

  const hourlyChipSx = {
    ...stayChipSx,
    ...chipSx,
  };

  const nightsChipSx = {
    ...bookedChipSx,
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
      <Typography
        variant="caption"
        sx={{
          color: isDark ? 'rgba(255,255,255,0.65)' : '#666',
          fontSize: '0.7rem',
          ...captionSx,
        }}
      >
        {meta.fieldLabel}
      </Typography>
      {meta.isActualStay ? (
        <>
          {meta.bookedChipLabel ? (
            <Chip
              label={meta.bookedChipLabel}
              size="small"
              title="Booked nights"
              sx={bookedChipSx}
            />
          ) : null}
          {meta.stayChipLabel ? (
            <Chip
              label={meta.stayChipLabel}
              size="small"
              title={meta.summaryText}
              sx={stayChipSx}
            />
          ) : null}
        </>
      ) : (
        <Chip
          label={meta.chipLabel}
          size="small"
          sx={meta.isHourly ? hourlyChipSx : nightsChipSx}
        />
      )}
    </Box>
  );
}
